import {MoreVert} from "@mui/icons-material";
import {IconButton, List, ListItem, Popover} from "@mui/material";
import {useState} from "react";
import APXDeleteAccount from "../APXDeleteAccount.jsx";
import APXLogout from "../APXLogout.jsx";
import {red_900} from "../js/APXTheme.js";
import APXPlusContactDeveloper from "./APXPlusContactDeveloper.jsx";


export default function APXPlusHeaderMenuWithPopover() {
	  const [anchorEl, setAnchorEl] = useState(null);
	  
	  const handleClick = (event) => {
			 setAnchorEl(event.currentTarget);
	  };
	  
	  const handleClose = () => {
			 setAnchorEl(null);
	  };
	  
	  const open = Boolean(anchorEl);
	  
	  const items = [
			 <APXPlusContactDeveloper/>,
			 <APXLogout/>,
			 <APXDeleteAccount/>
	  ];
	  
	  return (
				 <>
						<IconButton onClick={handleClick}>{<MoreVert sx={{color: red_900}}/>}</IconButton>
						<Popover open={open} anchorEl={anchorEl} onClose={handleClose}
									anchorOrigin={{vertical: "bottom", horizontal: "center"}}
									transformOrigin={{vertical: "top", horizontal: "right"}}>
							  <List dense>
									 {items.map((component, index) => <ListItem key={Math.random() + index}>{component}</ListItem>)}
							  </List>
						</Popover>
				 </>
	  );
}